import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import configReducer from './reducers/config.reducers';

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(configReducer,
  composeEnhancer(applyMiddleware(thunk))
  );

export default store;
